import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import * as ConfigTypes from 'config/ConfigTypes';
import UIButton from "components/UI/Button/Button";
import { getDialogConfig, getMetaConfig }
    from "helpers/ConfigHelper";
import { isHome } from 'helpers/AppHelper';
import { faEnvelope, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import CartTransport from "components/Cart/CartRequest/CartTransport/CartTransport";
import CartSelectList from "components/Cart/CartRequest/CartSelectList/CartSelectList";
import * as CartShare from "components/Cart/CartShare/CartShare";
import './CartRequest.scss'


const CartRequest = observer(
    class CartRequest extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                data: [],
                itemslist: [],
                userInputs: {},
                changeObj: {},
                isChanging: false
            }
        }

        fm = ({ id }) => {
            if (id) return this.props.intl.formatMessage({ id });
            return null;
        };

        getDeliveryShowFields = () => {
            let dialogMode = ConfigTypes.CARTREQUEST_DELIVERY;
            let showFields = getDialogConfig({
                dialogMode, configObjects: this.props.configObjects, configName: "userconfig"
            });
            return showFields;
        }

        getInvoiceShowFields = () => {
            let dialogMode = ConfigTypes.CARTREQUEST_INVOICE;
            let showFields = getDialogConfig({
                dialogMode, configObjects: this.props.configObjects, configName: "userconfig"
            });
            return showFields;
        }

        getTop = () => {
            return (
                <div className="cartrequest-topbox">
                    {ConfigTypes.CARTREQUEST_CLERK.map(item => {
                        return (
                            <>
                                {item.isBracket && '('}
                                <div>{item.intl && this.fm(item.intl)}&nbsp;</div>
                                {item.intl_bold && (
                                    <div className="cartrequest-bold">
                                        {this.fm({ id: item.intl_bold })}&nbsp;
                                    </div>
                                )}
                                <div className={`${item.isBold && 'cartrequest-bold'}`}>
                                    {this.state[item.name]}&nbsp;
                                </div>
                                {item.isBracket && ')'}
                            </>
                        )
                    })}
                </div>
            )
        }

        showHeadline = () => {
            return ConfigTypes.CARTREQUEST_HEADLINEDATA.map(el => {
                if (el.type === ConfigTypes.DROPDOWN) {
                    return (
                        <div className="cartrequest-dd-box">
                            <label>{this.fm({ id: el.intl })}</label>
                            <Dropdown
                                data={el.data} current={this.state.userInputs[el.name]}
                                onDDClick={(ddEl) => this.onDDClick({ ddEl, el })} />
                        </div>
                    )
                }
                return (
                    <div className={el.htmlClasses ? el.htmlClasses : 'cartrequest-details-row'}>
                        <label>{this.fm({ id: el.intl })}</label>
                        {this.props.cartObjects[el.name] && this.props.cartObjects[el.name]}
                    </div>
                )
            })
        }

        showSubHeadline = () => {
            return ConfigTypes.CARTREQUEST_SUBHEADLINEDATA.map(el => {
                if (el.type === ConfigTypes.BREAKLINE) return (<div className="cartrequest-line"></div>)
                return (
                    <div className={el.htmlClasses ? el.htmlClasses : ''}>
                        {this.fm({ id: el.intl })}
                    </div>
                )
            })
        }

        setUserInputs = ({ showFields, isBtnClk = null, }) => {
            let userInputs = { ...this.state.userInputs };
            let changeObj = {};
            if (showFields && showFields.length) {
                showFields.forEach(fi => {
                    if (fi.children && fi.children.length) {
                        fi.children.forEach(child => {
                            if (isBtnClk) changeObj[child.field] = !this.state.isChanging;
                            if (!this.state.userInputs[child.field]) {
                                userInputs[child.field] = this.props.user.metadata.fields[[child.field]] || '';
                            }
                        });
                    }
                    else {
                        if (isBtnClk) changeObj[fi.field] = !this.state.isChanging;
                        if (!this.state.userInputs[fi.field]) {
                            userInputs[fi.field] = this.props.user.metadata.fields[[fi.field]] || '';
                        }
                    }
                });
            }

            if (isBtnClk) {
                this.setState({ isChanging: !this.state.isChanging, changeObj, userInputs });
            }
            else this.setState({ userInputs });
        }

        initData = () => {
            let showFields = this.getDeliveryShowFields();
            let invoiceFields = this.getInvoiceShowFields();
            this.setUserInputs({ showFields: { ...showFields, invoiceFields } });
        }

        onDeliverAddClick = ({ showFields }) => {
            if (showFields && showFields.length) {
                this.setUserInputs({ showFields, isBtnClk: true });
            };
        }

        onInvoiceAddClick = ({ showFields }) => {
            if (showFields && showFields.length) {
                this.setUserInputs({ showFields, isBtnClk: true });
            };
        }

        onRowChange = ({ e, el }) => {
            this.setState({
                isChanged: true,
                userInputs: { ...this.state.userInputs, [el.field]: e.target.value }
            });
        }

        showBreakLine = (idx, noLine = false) => {
            return (
                <div className="cartrequest-breakline-box"
                    key={`cartrequest_breakline_${idx}`}>
                    <div className={!noLine && 'cartrequest-breakline'} />
                </div>)
        }

        showButton = ({ el, idx, icon = null, isRight = null, showFields = null }) => {
            return (
                <div className="cartrequest-row" key={`cartrequet_btn_${idx}${el.name}`}>
                    {isRight && <div />}
                    <UIButton textOnly onClick={() => this[el.onClick]({ el, showFields })}
                        className="cartrequest-button">
                        {this.fm({ id: el.intl })}
                        {icon && <FontAwesomeIcon icon={icon} />}
                    </UIButton>
                </div>)
        }


        showRowItem = ({ el, idx, isChild = null }) => {
            let classes = 'cartrequest-label ';
            if (isChild) {
                if (!el.isFirst) classes += ' cartrequest-right';
            }
            return (
                <div className="cartrequest-group" key={`showRow_${el.field}_${idx}`}>
                    <label className={classes}>
                        {this.fm({ id: el.intl })}:
                    </label>
                    <input type="text" value={this.state.userInputs[el.field]}
                        onChange={(e) => this.onRowChange({ e, el })} />
                </div>
            )
        }

        showRow = ({ el, canChange, text, idx }) => {
            if ((el.field && this.state.changeObj[el.field]) && canChange) {
                return this.showRowItem({ el, idx });
            }
            if (el.children && el.children.length && canChange) {
                let exists = el.children.find(child => child.field && this.state.changeObj[child.field]);
                if (exists) {
                    return el.children.map((child, index) => {
                        if (child.field && this.state.changeObj[child.field]) {
                            return this.showRowItem({ el: child, idx: index, isChild: true });
                        }
                    });
                }
            }
            return (
                <>
                    {el.withLabel && (<label className="cartrequest-label">
                        {this.fm({ id: el.intl })}:
                    </label>)}
                    <div className="cartrequest-text">{text}</div>
                </>)
        }

        showDetails = ({ showFields, icon = null, isRight = null, canChange = null }) => {
            if (showFields && showFields.length) {
                return showFields.map((el, idx) => {
                    if (el.type === ConfigTypes.BREAKLINE) {
                        return this.showBreakLine({ el, idx });
                    }
                    if (el.type === ConfigTypes.BUTTON) {
                        return this.showButton({ el, idx, icon, showFields });
                    }
                    let text = this.props.user.metadata.fields[`${el.field}`]
                        ? this.props.user.metadata.fields[`${el.field}`] : "";

                    if (this.state.userInputs[`${el.field}`]) text = this.state.userInputs[`${el.field}`];

                    if (typeof text == 'object' && text.intl) {
                        text = this.props.intl.formatMessage({ id: text.intl });
                    }
                    if (el.type && el.type === ConfigTypes.TEXT_FROM_CHILDREN
                        && el.children && el.children.length > 0
                    ) {
                        let all = el.children.map(child => {
                            if (this.state.userInputs[child.field]) return this.state.userInputs[child.field];
                            return this.props.user.metadata.fields[child.field];
                        });
                        if (all && all.length) text = all.join(" ");
                    }
                    return (
                        <div className="cartrequest-details-row"
                            key={`cartrequest_text_${el.field}${idx}`}>
                            {this.showRow({ el, canChange, text, idx })}
                        </div>
                    )
                })
            }
            return null;
        }
        showUserDetails = () => {
            let dialogMode = ConfigTypes.CARTREQUEST_USERDETAILS;
            let showFields = getDialogConfig({
                dialogMode, configObjects: this.props.configObjects, configName: "userconfig"
            });
            return this.showDetails({ showFields });
        }

        showDeliveryAddr = () => {
            let showFields = this.getDeliveryShowFields();
            showFields = [...showFields, ...ConfigTypes.CARTREQUEST_CHANGE_DELIVERY_ADDRESS];
            return this.showDetails({ showFields, icon: faEdit, canChange: true });
        }

        showInvoiceAddr = () => {
            let showFields = this.getInvoiceShowFields();
            showFields = [...showFields, ...ConfigTypes.CARTREQUEST_CHANGE_INVOICE_ADDRESS];
            return this.showDetails({ showFields, icon: faEdit, canChange: true });
        }

        showSingleItem = ({ item, idx }) => {
            let showFields = getMetaConfig({
                viewMode: ConfigTypes.CARTREQUEST_LIST, props: this.props,
                configName: ConfigTypes.ITEM
            });
            showFields = [...showFields, ...ConfigTypes.CARTREQUEST_ADDDATA];
            if (item && showFields && showFields.length) {
                return showFields.map((el, i) => {
                    let fieldTxt = CartShare.getFieldTxt({ item, el, i, idx });
                    if (el.type === ConfigTypes.INDEX) return null;
                    return (
                        <div key={`showItem_${Date.now()}_${i}`} className="cartrequest-itemslist-li-group">
                            <label>{this.fm({ id: el.intl })}</label>
                            <div className={`${el.htmlClasses ? el.htmlClasses : ''}`}>{fieldTxt}</div>
                        </div>
                    )
                })
            }
            return null;
        }

        showTableItem = ({ item, idx }) => {
            let viewMode = ConfigTypes.CARTREQUEST_TABLE;
            let showFields = getMetaConfig({
                viewMode, props: this.props,
                configName: ConfigTypes.ITEM
            });
            if (item && showFields && showFields.length) {
                return showFields.map((el, i) => {
                    let fieldTxt = CartShare.getFieldTxt({ item: item, el, i, idx, viewMode });
                    return (
                        <div key={`showItem_${Date.now()}_${i}`} className="cartrequest-itemslist-li-group">
                            <label>{this.fm({ id: el.intl })}</label>
                            <div className={`${el.htmlClasses ? el.htmlClasses : ''}`}>{fieldTxt}</div>
                        </div>
                    )
                })
            }
            return null;
        }

        showElement = ({ el, idx, icon = null, isRight = null }) => {
            switch (el.type) {
                case ConfigTypes.BREAKLINE:
                    return this.showBreakLine(idx, el.noLine);
                case ConfigTypes.BUTTON:
                    return this.showButton({ el, idx, icon, isRight });
                case ConfigTypes.LINK:
                    return this.showLink({ el, idx });
                case ConfigTypes.TEXT:
                case ConfigTypes.TEXT_FROM_CHILDREN:
                    return this.showText({ el, idx });
                case ConfigTypes.INFO:
                    return this.showInfo({ el, idx });
                case ConfigTypes.ITEMS_CARTLIST:
                    return this.showCartList({ el, idx });
                case ConfigTypes.INVOICE:
                    return this.showOtherData({ el, idx, data: this.props.cartObjects });
                case ConfigTypes.OWNER_INST:
                    return this.showOtherData({ el, idx, data: this.props.owner, withSpace: false });
                default:
                    return (
                        <div key={`cartrequest_ul_li_children_child${idx}`}>{el.name}</div>
                    )
            }
        }

        showActions = () => {
            return ConfigTypes.CARTREQUEST_ACTIONS.map((el, idx) => {
                return this.showElement({ el, idx, icon: faEnvelope, isRight: true })
            })
        }

        handleCbChange = ({ e, el }) => {
            this.setState({ userInputs: { ...this.state.userInputs, [el.field]: e.target.checked } });
        }

        onDDClick = ({ ddEl, el }) => {
            console.log("LOGS: CartRequest onDDClick", ddEl, el);
            const { cartReqObj } = this.props.cartObjects;
            this.setState({ userInputs: { ...this.state.userInputs, [el.field]: ddEl.name } });
            this.props.updateCartObjects({ cartReqObj: { ...cartReqObj, [el.field]: ddEl.name } });
        }

        getDelivPars = ({ pars }) => {
            let dlgMode = ConfigTypes.CARTREQUEST_DELIVERY;
            let showFields = this.getDeliveryShowFields();
            if (showFields && showFields.length) {
                showFields.forEach(fi => {
                    if (fi.children && fi.children.length) {
                        let firstVal = '';
                        fi.children.forEach(child => {
                            if (child[`${dlgMode}parents`] && child[`${dlgMode}parents`].submitField
                                && this.state.userInputs[child.field]) {
                                let sub = child[`${dlgMode}parents`].submitField;
                                pars[sub] = firstVal + this.state.userInputs[child.field];
                            } else {
                                if (child.isFirst && this.state.userInputs[child.field]) {
                                    firstVal = `${this.state.userInputs[child.field]} `;
                                }
                            }
                        })
                    } else {
                        if (fi.params && fi.params[dlgMode] && fi.params[dlgMode].submitField
                            && this.state.userInputs[fi.field]) {
                            let sub = fi.params[dlgMode].submitField;
                            pars[sub] = this.state.userInputs[fi.field];
                        }
                    }
                })
            }
            return pars;
        }

        sendRequest = () => {
            const { cartReqObj } = this.props.cartObjects;
            let pars = { ...cartReqObj };
            if (this.state.isChanged) pars = this.getDelivPars({ pars });
            console.log("LOGS: CartRequest sendRequest pars", pars);
            this.props.sendFeReSubmitCart(pars);
        }

        onSendRequestClick = ({ el }) => {
            if (el.name && el.name === ConfigTypes.SEND_REQUEST) {
                this.sendRequest();
            }
            if (!isHome()) this.props.router.navigate("/");
            this.props.updateMediaObjects({ viewMode: ConfigTypes.LIST });
        }

        componentDidMount() {
            this.initData();
        }

        render() {
            return (
                <div className="cartrequest">
                    <div className="cartrequest-content">
                        <div className="cartrequest-top">
                        </div>
                        <div className="cartrequest-userdetails">
                            {this.showUserDetails()}
                        </div>
                        <div className="cartrequest-headline">
                            {this.showHeadline()}
                        </div>
                        <div className="cartrequest-subheadline">
                            {this.showSubHeadline()}
                        </div>
                        <CartSelectList />
                        <CartTransport />
                        <div className={`cartrequest-delivery 
                            ${this.state.isChanging ? 'cartrequest-change' : ''}`}>
                            <div className="cartrequest-bold-ms">
                                {this.fm({ id: 'cartrequest.contact' })}
                            </div>
                            {this.showDeliveryAddr()}
                        </div>
                        <div className={`cartrequest-delivery 
                            ${this.state.isChanging ? 'cartrequest-change' : ''}`}>
                            {this.showInvoiceAddr()}
                        </div>
                        <div className="cartrequest-actions">
                            {this.showActions()}
                        </div>
                    </div>
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects,
    user: state.auth.authObjects.user,
    owner: state.auth.authObjects[ConfigTypes.INST_DATA]["kinemathek"]
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    sendFeReSubmitCart: (obj) => dispatch(actions.sendFeReSubmitCart(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CartRequest))));


